module.exports = __webpack_public_path__ + "static/img/penny.4df0885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/penny.png
// module id = iY3W
// module chunks = 0